import React, { useDebugValue, useEffect, useRef, useState } from "react"
import { graphql, Link } from "gatsby"

import { connect } from 'react-redux';

import Button from "../components/basic-components/button";
import { navigate } from "gatsby-link";

import { getAllProducts } from '../store/selectors';

import { emptyCartMessage } from '../store/actions';
import { addToCartMessage } from '../store/actions';
import { validateEmail, validatePostcode } from "../utils/customFunctions"

const EnquiryPopup = ({data, products, emptyCart}) => {

    const [anyError, setAnyError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [postcodeError, setPostcodeError] = useState(false);
    const [firstnameError, setFirstnameError] = useState(false);
    const [surnameError, setSurnameError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [cemeteryError, setCemeteryError] = useState(false);

    var orderProducts = [];
    //console.log("[>>] products length = " + products.length);
    //anna to do: check products.map - throws error since it founds products as object and should be array 
    
    products.map(( { product, count }, i) => {

        orderProducts.push({
          "ItemId": product.itemId,
          "MaterialId": product.materialId,
          "SizeId": product.sizeId,
          "Quantity": 1,
          "HidePrices": product.hidePrice
        })

      });
    
    console.log("[>>] enquiry  products:" + products)

    const handleGtag = (title) => {
        if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {
    
          window.gtag('event', 'add_to_cart', { 'event_category': 'ecommerce', 'event_label': `${title}` });
    
        }
      }

    const validate = () =>{
        let error = 0;

        let email = document.getElementById("order-email").value;
        let postcode = document.getElementById("order-postcode").value;
        let salutation = document.getElementById("order-salutation").value;
        let firstname = document.getElementById("order-first-name").value;
        let surname = document.getElementById("order-surname").value;
        let phone = document.getElementById("order-phone").value;
        let address = document.getElementById("order-address").value;
        let cemetery = document.getElementById("order-cemetery").value;


        if(firstname == "")
        {
            setFirstnameError(true);
            error = 1;
        }
        else{
            setFirstnameError(false);
        }

        if(surname == "")
        {
            setSurnameError(true);
            error = 1;
        }
        else{
            setSurnameError(false);
        }

        if(phone == "")
        {
            setPhoneError(true);
            error = 1;
        }
        else{
            setPhoneError(false);
        }

        if(address == "")
        {
            setAddressError(true);
            error = 1;
        }
        else{
            setAddressError(false);
        }

        if(cemetery == "")
        {
            setCemeteryError(true);
            error = 1;
        }
        else{
            setCemeteryError(false);
        }
    

        if(email =="" || !validateEmail(email)) {
            setEmailError(true);
            error = 1;
        }
        else{
            setEmailError(false);
        }

        if (postcode == "" || !validatePostcode(postcode)) {
            setPostcodeError(true)
            error = 1;
        }
        else{
            setPostcodeError(false)
        }

        if (error) {
            setAnyError(true)
            return false 
        }

        setAnyError(false)
        
        return true
    }

    const refreshPage = () => { 
        alert("refresh page");
        window.location.reload(); 
    }

    const checkoutResponse = useRef();
    const checkoutBasketContents = useRef();
    const checkoutCustomerDetails = useRef();

    const sendOrderTest = () => {  
        var order = {
    
          "Customer": {
            "Email": document.getElementById("order-email").value,
            "Salutation": document.getElementById("order-salutation").value,
            "FirstName": document.getElementById("order-first-name").value,
            "Surname": document.getElementById("order-surname").value,
            "Address": document.getElementById("order-address").value,
            "Postcode": document.getElementById("order-postcode").value,
            "Mobile": document.getElementById("order-phone").value,
            "BillingContactName": document.getElementById("order-first-name").value,
            "BillingSalutation": document.getElementById("order-salutation").value,
            "BillingAddress": document.getElementById("order-address").value,
            "BillingPostcode": document.getElementById("order-postcode").value,
          },
    
          "Cemetery": document.getElementById("order-cemetery").value,
          "Notes": document.getElementById("order-message").value,
          "AcceptOffers": document.getElementById("order-offers").checked,

          // "Products": [{
          //     "ItemId": "13",
          //     "MaterialId": "34",
          //     "SizeId": "14",
          //     "Quatity": "2"
          // }],
          
          //anna to do: check products.map - throws error since it founds products as object and should be array 
          "Products": orderProducts, 
    
          "TotalPrice": "0.00"
        }
    
        // console.log(order);
        var submitBtn = document.getElementById("confirm-order").firstChild;
        submitBtn.innerHTML = '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="spinner" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"></path></svg>';
        submitBtn.classList.add("form-submitting");
        // document.getElementById("confirm-order").firstChild.classList.add("form-submitting");
    
        var body = {
          data: JSON.stringify(order)
        };
    
        fetch(process.env.GATSBY_CHECKOUT_FETCH_ADDRESS, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json'
          }
    
        }).then(response => {
          //  console.log(response)
          //  console.log("status" + response.status)
          //  console.log("quoteNo" + response.quoteNo)
          // console.log("response: " + response.ok)
          if (!response.ok) {
            // throw new Error('network response was not OK')
            // console.log("error sending")
            submitBtn.innerHTML = "Oops... Try again!"
            submitBtn.classList.remove("form-submitting")
    
          } else {
    
            response.json().then(json => {
    
              if (json.status === "Success") {
                // console.log("sent ok")
    
                if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined'){
                    window.gtag('event', 'complete_enquiry', {'value': `0.00`, 'currency': 'GBP'})
                }
    
                submitBtn.innerHTML = "Enquiry sent!"
                document.getElementById("order-response-number").innerHTML = json.quoteNo
                //document.getElementById("order-response-payment-url").innerHTML = json.onlinePaymentUrl
                document.getElementById("modalTitle").classList.add("uk-hidden")
                document.getElementById("divider").classList.add("uk-hidden")
                submitBtn.classList.remove("form-submitting")
                checkoutResponse.current.firstChild.classList.remove("uk-hidden")
                checkoutCustomerDetails.current.firstChild.classList.add("uk-hidden")
                
                //anna to do: check products.map - throws error since it founds products as object and should be array 
                emptyCart({})
    
                if (json.onlinePaymentUrl) {
                  navigate(json.onlinePaymentUrl)
                }
    
              }
              else {
                // console.log("sent but not ok: " + json.message)
                submitBtn.classList.remove("form-submitting")
                submitBtn.classList.add("red-state")
                submitBtn.innerHTML = "Something went wrong... Try again!"
    
              }
            })    
    
          }

        }
        )
        // .then(result => console.log("result" + result.json()))
        // console.log("Message sent");
    
        //event.preventDefault();
    }

    const checkForm =  () => {
        let isValid = validate()
        if(isValid) {
          if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined'){
           //window.ga('send', 'event', 'TriggerCheckout', 'submit');
           window.gtag('event', 'click', {'event_category':'trigger_enquiry', 'event-label':'submit'});
          }
          sendOrderTest();
        }
    }

    const resetPopup = () => {
        var submitBtn = document.getElementById("confirm-order").firstChild;
        submitBtn.innerHTML = "Submit"
        checkoutCustomerDetails.current.firstChild.classList.remove("uk-hidden")
        checkoutResponse.current.firstChild.classList.add("uk-hidden")
    }

    return(
        <div id="enquiry-popup" className="overlay">
            <div className="popup">
              {/* <p className="popup-title" id="modalTitle">Please enter your details so our team can contact you, or <a className="cont-browsing" href="#">continue browsing.. </a> to add more items on your quote.</p> */}
              <div className="popup-title" id="modalTitle">Your details</div>
              <a className="close" href="#" onClick={resetPopup}>&times;</a>
              <div className="content">
                <hr id="divider" />
                <section id="checkout-customer-details " ref={checkoutCustomerDetails}>
                  <div className="checkout-customer-details ">
                    
                    <h5>All fields are required</h5>
                    <form className="uk-grid-small " id="memorials-checkout" 
                        // onSubmit={sendOrderTest} 
                        onSubmit={e => e.preventDefault()}
                        data-uk-grid>
                      <fieldset className="uk-fieldset no-padding-right">

                        <div className="" data-uk-grid>

                          <div className="uk-margin uk-width-1-3@m">
                            <label className="uk-form-label" htmlFor="form-stacked-text">Salutation</label>
                            {/* <input id="order-salutation" className="uk-input" type="text" placeholder="Example: Mr. John" required/> */}
                            <select id="order-salutation" className="uk-input" placeholder="Select title">
                                <option value={""}>―Select an option―</option>
                                <option value={"Mr"}>Mr</option>
                                <option value={"Miss"}>Miss</option>
                                <option value={"Mrs"}>Mrs</option>
                                <option value={"Ms"}>Ms</option>
                                <option value={"Mr & Mrs"}>Mr &amp; Mrs</option>
                                <option value={"Dr"}>Dr</option>
                                <option value={"Rev"}>Rev</option>
                                <option value={"Professor"}>Professor</option>
                                <option value={"Lord"}>Lord</option>
                                <option value={"Lady"}>Lady</option>
                                <option value={"Sir"}>Sir</option>
                            </select>
                          </div>

                          <div className="uk-margin  uk-width-1-3@m form-field">
                            <label className="uk-form-label" htmlFor="form-stacked-text">First Name</label>
                            <input id="order-first-name" 
                                //className="uk-input" 
                                className={`${firstnameError ? 'border-error' : ''} uk-input`}
                                type="text" placeholder="Example: John" required />
                            {
                                firstnameError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Firts Name is required.</p> : ""
                            }
                          </div>

                          <div className="uk-margin uk-width-1-3@m form-field">
                            <label className="uk-form-label" htmlFor="form-stacked-text">Surname</label>
                            <input id="order-surname" 
                                //className="uk-input" 
                                className={`${surnameError ? 'border-error' : ''} uk-input`}
                                type="text" placeholder="Example: Smith" required />
                            {
                                surnameError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Surname is required.</p> : ""
                            }
                          </div>
                        </div>

                        

                        {/* <div className="divider"></div> */}

                        <div className="" data-uk-grid>
                          <div className="uk-margin uk-width-1-2@m form-field">
                            <label className="uk-form-label" htmlFor="form-stacked-text">Email address</label>
                            <input id="order-email" 
                                    className={`${emailError ? 'border-error' : ''} uk-input`}
                                    //className="uk-input" 
                                    type="text" placeholder="Example: name@example.com" required />
                             {
                                emailError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Please enter a valid email address.</p> : ""
                              }
                          </div>

                          <div className="uk-margin uk-width-1-2@m form-field">
                            <label className="uk-form-label" htmlFor="form-stacked-text">Phone No</label>
                            <input id="order-phone" 
                                //className="uk-input"
                                className={`${phoneError ? 'border-error' : ''} uk-input`} 
                                type="text" placeholder="Example: 012 3456 7890" required />
                            {
                                phoneError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Phone is required.</p> : ""
                            }
                          </div>
                        </div>

                        <div className="" data-uk-grid>
                          <div className="uk-margin uk-width-1-2@m form-field" >
                            <label className="uk-form-label" htmlFor="form-stacked-text">Postcode</label>
                            <input id="order-postcode" 
                                className={`${postcodeError ? 'border-error' : ''} uk-input`}
                                //className="uk-input" 
                                type="text" placeholder="Ex: DA8 3NU" required />
                            {
                                postcodeError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Please enter a valid postcode.</p> : ""
                            }
                          </div>
                          
                          <div className="uk-margin uk-width-1-2@m form-field">
                            <label className="uk-form-label" htmlFor="form-stacked-text">Address</label>
                            <input id="order-address" 
                                //className="uk-input" 
                                className={`${addressError ? 'border-error' : ''} uk-input`}
                                type="text" placeholder="Example: London, 91 Western Road" required />
                            {
                                addressError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Addreess is required.</p> : ""
                            }
                          </div>                          
                        </div>

                        {/* <div className="divider"></div> */}
                        <div className="" data-uk-grid>
                            <div className="uk-margin uk-width-1-1@m">
                                <label className="uk-form-label" htmlFor="form-stacked-text">Cemetery/Churchyard</label>
                                <input id="order-cemetery" 
                                    //className="uk-input" 
                                    className={`${cemeteryError ? 'border-error' : ''} uk-input`}
                                    type="text" placeholder="Cemetery name" required/>
                                {
                                    cemeteryError ? <p style={{ color: 'red', margin: "20px 0px 0px 0px" }}>Please enter the cemetery details.</p> : ""
                                }
                            </div>
                        </div>

                        <div className="" data-uk-grid>
                          <div className="uk-margin uk-width-1-1@s">
                            <label className="uk-form-label" htmlFor="form-stacked-text">How can we help?</label>
                            <textarea id="order-message" className="uk-input" name="text" rows="3" placeholder="" ></textarea>
                          </div>
                        </div>

                        <div className="" data-uk-grid>
                          <div className="uk-margin uk-width-1-1@s">
                            <label className="uk-form-label" htmlFor="form-stacked-text">
                              <input type="checkbox" id="order-offers" name="product-type" value="Accept Offers" ></input>
                              We’d like to send you further information about our products and services, including special offers and recommendations. To receive these occasional emails, check this box.
                            </label>
                          </div>
                        </div>


                      </fieldset>

                      <div className="" data-uk-grid>
                        <div id="confirm-order" 
                            // onClick={() => handleGtag(page.Name)}
                            onClick={() => checkForm()}
                            ><Button use="addToCart" label="Submit"></Button></div>
                      </div>

                      {
                        anyError ? <p style={{ color: 'red', paddingBottom: "30px", margin: "0" }}>One or more fields have an error. Please check and try again.</p> : ""
                      }
                    </form>
                  </div>
                </section>

                <section id="checkout-response " ref={checkoutResponse}>
                  <div className="checkout-response uk-hidden padding-top padding-bottom">
                    {/* <h2>Order complete</h2> */}
                    <h3>Thank you for your enquiry, we are processing your request and will be in touch shortly.</h3>



                    <div className="" data-uk-grid>
                      <div className="uk-padding-remove uk-width-1-1">

                        <div className="checkout-response-field">
                          <div>Reference number: <span id="order-response-number"></span></div>
                          {/* <div><a id="order-response-payment-url">Proceed to payment</a></div> */}
                        </div>
                        <div className="divider"></div>
                        <div className="">
                          <Link to="" >
                            <Button use="" label="Continue browsing"></Button>
                          </Link>
                        </div>



                      </div>
                    </div>
                  </div>
                </section>


              </div>
            </div>
          </div>
    )
    
}

function mapStateToProps({ cartReducer }) {
    return {
        products: getAllProducts(cartReducer)
    };
}

const mapDispatchToProps = {
    //addToCart: (product, count) => addToCartMessage(product, count),
    emptyCart: product => emptyCartMessage(product),
  };

 export default connect(
    mapStateToProps,
    mapDispatchToProps
  ) (EnquiryPopup)

